/**
 * Platform codes from GET /subscriptions/access/status/ (aligned with backend / PLATFORM_URL_MAP).
 */
export const PLATFORM_CODES = {
  CAMPUS: 'campus',
  OFFERS: 'offers',
  TRACKTALENT: 'tracktalent',
  INTERVIWATCH: 'interviwatch'
} as const

/** This app is Launchpad (backend platform code: "campus"). */
export const DEFAULT_APP_PLATFORM = PLATFORM_CODES.CAMPUS
